/* eslint-disable import/prefer-default-export */
import { ref } from 'vue';

import { StyleExtensionFunctionType } from '@v1/composables/sfc-types';

export const useStyleExtension: StyleExtensionFunctionType = (extension) => ref({
  image: {
    height: 'auto',
    maxHeight: '100%',
    maxWidth: '100%',
    minHeight: 0,
    minWidth: 0,
    width: '100%',
    ...extension.image,
  },
});
